<div class="row">
  <div class="col-12 pb-2">
    <div class="col-9 mx-auto">
      <div class="d-flex justify-content-center align-items-center flex-column">
        <div class="bg-warning text-center p-3 rounded shadow-sm mt-2">
          <div class="small text-uppercase fw-bold mb-1">Current Ranking</div>
          <div class="display-4 fw-bold">{{effectiveRanking}}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="ranking-bar-shell mb-4">
      <div class="ranking-scale-grid ranking-scale-labels">
        @for (num of numbers; track num) {
          <div class="ranking-scale-cell">
            <span>{{num}}</span>
          </div>
        }
      </div>

      <div class="ranking-bar-track" #trackRoot role="progressbar" aria-label="Customer ranking scale">
        <div class="ranking-scale-grid ranking-bar-grid">
          @for (num of numbers; track num) {
            <div
              class="ranking-bar-segment"
                            [ngClass]="{
                                'bg-danger': num <= 3,
                                'bg-danger-subtle': num === 4 || num === 5,
                                'bg-warning': num >= 6 && num <= 10,
                                'bg-success-subtle': num === 11 || num === 12,
                                'bg-success': num >= 13
                            }"
              [attr.aria-valuenow]="num"
              [attr.aria-valuemin]="1"
              [attr.aria-valuemax]="15">
            </div>
          }
        </div>

        <div class="ranking-scale-grid ranking-scale-ticks">
          @for (num of numbers; track num) {
            <div class="ranking-scale-cell">
              <div class="vertical-line"></div>
            </div>
          }
        </div>

        <div class="position-absolute ranking-arrow" [style.left.px]="arrowLeftPx" aria-hidden="true">
          <span class="ranking-arrow-head"></span>
        </div>
      </div>
    </div>
  </div>
  @if (!readonlyRankingBar) {
    <div class="col-md-6 col-12 mx-auto">
      <div class="my-2 w-100 d-flex flex-column align-items-center">
        <label for="rankingInput" class="form-label small text-uppercase fw-bold">Ranking</label>
        <div class="input-group">
          <input type="number"
            class="form-control text-center"
            id="rankingInput"
            [value]="ranking"
            (input)="onRankingInput($event)"
            [disabled]="readonlyRankingBar"
            min="0"
            max="15">
        </div>
      </div>
    </div>
  }
</div>